import React, { useEffect, useState } from 'react';
import { View, Text, StyleSheet, BackHandler, Platform, StatusBar, TouchableOpacity, ActivityIndicator, FlatList, Linking, SafeAreaView, TextInput, RefreshControl, } from 'react-native';
import Btn from "../components/btn"
import Colors from '../constants/Colors';
import { Ionicons, MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons"
import { useDispatch, useSelector } from 'react-redux';
import { getAllOrder, GetIDgroup, SendName, UpdateOrder } from '../store/action/finalproduct';
import AwesomeAlert from 'react-native-awesome-alerts';
import { Box, Center, HStack, Icon, IconButton, Modal, NativeBaseProvider, Stagger, useDisclose, useMediaQuery } from 'native-base';
import { useIsFocused } from '@react-navigation/native';
import { getProfileinfo, logOut } from '../store/action/userLogin';
import AsyncStorage from '@react-native-async-storage/async-storage';
import INPU from '../components/input';










const Orderlist = (props) => {

    //const tokens = "2|WHyjzuT213icASOZyDMHFmRUaYcJfLA5S9Y9kjhh"
    const tokens = useSelector((store) => store.userLogin.datatoken);
    const dispatch = useDispatch();
    const [ERROR, setError] = useState(false);
    const [Offset, setOffset] = useState(2);
    const [Massage, setMassage] = useState();
    const [dataSource, setDataSource] = useState([]);
    const [Number, setNumber] = useState("");
    const [name, setname] = useState("");
    const [Last, setLast] = useState(1);
    const [filtermodal, setfiltermodal] = useState(false);
    const [mobile, setmobile] = useState("");
    const [Userid, setuserid] = useState("");
    const [State, setState] = useState({

        showModal: false,
        isLoading: false,
        isLoading1: false,
        name: "",
        nameservice: "",
        ActService: "",

    })

    const logOutHandler = async () => {
        try {
            //   console.log("logout");
            await dispatch(logOut());
            await AsyncStorage.removeItem("access_token");
            props.navigation.navigate("splash");
        } catch (err) {
            console.log(err);
        }
    };





    function handleBackButtonClick() {

        props.navigation.navigate("home");
        return true;


    }

    useEffect(() => {
        BackHandler.addEventListener("hardwareBackPress", handleBackButtonClick);
        return () => {
            BackHandler.removeEventListener("hardwareBackPress", handleBackButtonClick);
        };
    }, []);


    const loadMore = async () => {
        if (parseInt(Offset) <= parseInt(Last)) {

            if (Offset == 1) {
            } else {
                setOffset(Offset + 1);
            }
            getORDERHandlerLoad();
        }
    };
    const getORDERHandlerLoad = async (reload = 'false') => {

        try {

            // let offset = Offset; 


            setState({ ...State, isLoading: true })
            const res = await dispatch(getAllOrder(tokens,
                Offset,
                name,
                State.ActService


            ));

            setDataSource([...dataSource, ...res.data.data.orders.data])


            setNumber(res.data.data.count)

            setState({ ...State, isLoading: false })

        } catch (err) {
            // logOutHandler()
        }
    };

    const getORDERHandler = async (reload = 'false') => {

        try {
            setState({ ...State, isLoading: true })


            // console.log(name);
            const res = await dispatch(getAllOrder(tokens,
                1,
                name,
                State.ActService


            ));

            setDataSource([...res.data.data.orders.data])


            setLast(res.data.data.orders.last_page)

            //  console.log(res.data.data.orders.data);
            setNumber(res.data.data.count)

            setState({ ...State, isLoading: false })

        } catch (err) {
            // logOutHandler()
        }
    };


    const isfocuce = useIsFocused();
    useEffect(() => {
        getORDERHandler();
        getprofileHandler()

        if (props.route.params.refresh == "true") {
            setOffset(2)
        }

        if (!tokens) {
            logOutHandler()
        }

    }, [isfocuce])




    // const handleGetidgroup = async (idgroup) => {

    //     try {
    //         const res = await dispatch(GetIDgroup(idgroup));


    //     } catch (err) {
    //         console.log(err);
    //     }
    // };







    // const UPDATEHandler = async (idorder) => {
    //     try {


    //         const res = await dispatch(UpdateOrder(tokens, idorder))

    //         if (res.status == "success") {
    //             setError(true)
    //             setMassage("با موفقیت ثبت شد")
    //             setOffset(2)
    //             getORDERHandler();
    //         } else if (res.status == "error") {
    //             setError(true)
    //             setMassage(res.message)
    //         }
    //         //console.log(res);

    //     } catch (err) {
    //         // logOutHandler()
    //     }
    // };



    const SendNameHandler = async (idorder) => {
        try {


            const res = await dispatch(SendName(tokens, idorder, State.name))

            if (res.status == "success") {
                setError(true)
                setMassage("با موفقیت ثبت شد")

            } else if (res.status == "error") {
                setError(true)
                setMassage(res.message)
            }
            console.log(res);

        } catch (err) {
            // logOutHandler()
        }
    };






    const handleOpenWithLinkingPayment = (url) => {
        Linking.openURL(url);
    };


    // const handleOpenlinkpayment = (factor_id) => {
    //     Linking.openURL("https://npln.ir/payment/factor?user_id=" + Userid + "&mobile=" + mobile + "&factor_id=" + factor_id);
    // };





    const [isSmallScreen] = useMediaQuery({
        // minHeight: 280,
        // maxHeight: 480,
        maxWidth: 500
    });



    //پروفایل 
    const getprofileHandler = async () => {
        try {

            const res = await dispatch(getProfileinfo(tokens));
            // console.log(res.data.data);

            setmobile(res.data.data.user.mobile)
            setuserid(res.data.data.user.id)

        } catch (err) {

            //logOutHandler()
        }
    };





    return (

        <NativeBaseProvider>




            <View
                style={{
                    width: isSmallScreen ? "100%" : 500,
                    height: "100%",
                    marginLeft: isSmallScreen ? 0 : "35%",
                    backgroundColor: Colors.background,
                    position: Platform.OS == "web" ? "fixed" : "relative"
                }}>






                <View style={styles.viewHeader}>

                    <StatusBar backgroundColor={Colors.primary} />
                    <TouchableOpacity onPress={() => props.navigation.navigate("home")} style={styles.menu}   >
                        <Ionicons name="arrow-forward-outline" size={25} color={Colors.background} />
                    </TouchableOpacity>

                    <TouchableOpacity onPress={() => props.navigation.navigate("home")} style={styles.textheader}>
                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.background, padding: "5%" }}>
                            لیست سفارشات
                        </Text>
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.filter1} onPress={() => props.navigation.navigate("mdfwhite")}  >


                   
                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.background }}>سفارش جدید</Text> 
                        {/* <MaterialCommunityIcons name={""} size={25} color={Colors.background} /> */}
                    </TouchableOpacity>
                    <TouchableOpacity style={styles.filter} onPress={() => props.navigation.navigate("splash")}  >


                        <Text style={{ fontFamily: "Montserrat", fontSize: 13, color: Colors.background }}>بارگزاری مجدد</Text>
                        <MaterialCommunityIcons name={"reload"} size={25} color={Colors.background} />
                    </TouchableOpacity>


                    {/* <TouchableOpacity onPress={() => setfiltermodal(true)} style={styles.filter}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, padding: "5%" }}>
                            فیلتر
                        </Text>
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>بارگزاری مجدد</Text>
                        <MaterialCommunityIcons name="sort-ascending" size={25} color={Colors.background} />
                    </TouchableOpacity> */}





                </View>
                <Modal justifyContent="center" size="lg"
                    isOpen={filtermodal} onPress={() => setfiltermodal(false)}>
                    <Modal.Content style={{ borderRadius: 30 }}>
                        <Modal.Body >

                            <View style={{ width: "100%", height: 200 }}>
                                <View style={{ width: "100%", height: 40, }}>
                                    <Text style={styles.textmodal}>انتخاب  فیلتر</Text>
                                    <Ionicons onPress={() => setfiltermodal(false)} name="close" size={20} color={Colors.black} />
                                </View>



                                <View style={{ width: "100%", height: 100, marginBottom: 10 }}>



                                    <View style={{ width: Platform.OS === "web" ? "95%" : "92%", height: 40, flexDirection: "row", alignItems: "center", marginBottom: "4%" }}>
                                        <Ionicons onPress={() => setState({ ...State, ActService: "send" })} name={State.ActService !== "send" ? "square-outline" : 'checkbox'}
                                            size={28} color={State.ActService !== "send" ? Colors.secondText3 : Colors.yellowlight} />


                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, position: "absolute", right: 0 }}>  سفارشات ارسال شده :</Text>
                                    </View>

                                    <View style={{ width: Platform.OS === "web" ? "95%" : "92%", height: 40, flexDirection: "row", alignItems: "center", }}>
                                        <Ionicons onPress={() => setState({ ...State, ActService: "pending" })} name={State.ActService !== "pending" ? "square-outline" : 'checkbox'}
                                            size={28} color={State.ActService !== "pending" ? Colors.secondText3 : Colors.yellowlight} />

                                        <Text style={{ fontFamily: "MontserratBold", fontSize: 12, color: Colors.black, position: "absolute", right: 0 }}>  سفارشات در انتظار ارسال :</Text>
                                    </View>


                                </View>








                                <Btn
                                    touchableStyle={{
                                        width: "80%",
                                        height: 50,
                                        backgroundColor: Colors.primary,
                                    }}
                                    textStyle={{ bottom: 10, fontSize: 16 }}
                                    style={{ marginTop: 10, bottom: 10, left: 25 }}
                                    onPress={() => {

                                        setfiltermodal(false)
                                        setOffset(2)
                                        getORDERHandler()


                                    }}
                                    colorspin={Colors.background}
                                    sizespin={25}
                                    label="ثبت"

                                />





                            </View>


                        </Modal.Body>

                    </Modal.Content>
                </Modal>



                <View style={{ flexDirection: "row", width: "100%", height: 70, marginBottom: 10 }}>

                    <TextInput

                        placeholder="جست وجو در سفارشات"
                        onKeyPress={() => {
                            setOffset(2)
                            getORDERHandler()
                        }}

                        keyboardType="default"
                        placeholderTextColor={Colors.secondText3}
                        style={styles.textinput}
                        onChangeText={(e) => setname(e)}



                    />

                    <MaterialCommunityIcons name="magnify" size={30} color="#767F9D" style={{ position: "absolute", right: "8%", top: 30, zIndex: 2 }} />

                </View>



                {State.isLoading && Platform.OS == "web" ?
                    <View style={{ flexDirection: "row", width: 100, height: 40, backgroundColor: Colors.yellowdark, borderRadius: 10, alignItems: "center", justifyContent: "center", top: "80%", left: "38%", position: "absolute", zIndex: 2 }}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, marginRight: 10 }}>
                            بیشتر
                        </Text>
                        <ActivityIndicator size={30} color={Colors.background} />
                    </View>
                    :
                    <View></View>}







                {dataSource.length !== [] ?

                    <FlatList
                        refreshControl={
                            <RefreshControl
                                refreshing={State.isLoading}
                                onRefresh={() => {
                                    setOffset(2)
                                    getORDERHandler()
                                }}
                                progressViewOffset={150}
                                colors={[Colors.background]}
                                progressBackgroundColor={Colors.yellowlight}
                                size="large"

                            />
                        }







                        style={{ marginBottom: Platform.OS == "web" ? 30 : 0 }}
                        data={dataSource}

                        onEndReachedThreshold={0.5}
                        keyExtractor={(item, index) => index.toString()}
                        // inverted={Platform.OS == "web" ? false : true}
                        onEndReached={() => loadMore()}
                        //    ListFooterComponent={renderFooter}
                        enableEmptySections={true}

                        renderItem={({ item, index }) => {
                              ///console.log(item);
                            return (

                                <View

                                    key={index} style={{
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "90%",
                                        alignSelf: "auto",
                                        backgroundColor: Colors.background1,
                                        marginTop: 10,
                                        left: "5%",
                                        borderWidth: 2,
                                        borderColor: Colors.secondText,
                                        borderRadius: 10,

                                        marginBottom: dataSource.length > 1 ? 10 : 290
                                    }}>

                                    <Text style={{ textDecorationLine: 'underline', fontFamily: "MontserratBold", fontSize: 20, color: Colors.primarydark, left: "3%", position: "absolute" }}> {Number - index} </Text>
                                    <View style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "flex-end", width: "100%", alignSelf: "auto", marginTop: 5, marginBottom: 15, right: 15 }}>


                                        {item.logs.length ?

                                            item.logs.map((item, i) => {
                                                return (
                                                    //   .split(" ")[0]
                                                    <View key={i} style={{ alignItems: "center", flexDirection: "column", width: "30%", height: 80, marginBottom: 10, marginTop: 10 }}>
                                                        <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.secondText3, }}>{item.date_show}</Text>
                                                        <View style={{ width: "100%", height: 2, backgroundColor: Colors.secondText, right: 3, top: 15, zIndex: 1 }}></View>
                                                        <MaterialCommunityIcons name="check-circle" size={25} color={Colors.success} style={{ zIndex: 2 }} />
                                                        <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.secondText3, top: 5, }}>{item.text}</Text>
                                                    </View>
                                                )
                                            })
                                            :
                                            <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.primary, marginTop: 10 }}>درحال بررسی</Text>

                                        }



                                    </View>



                                    <View style={{ width: "100%", alignSelf: "auto", flexDirection: "row", justifyContent: "flex-end", marginBottom: 10 }}  >

                                        <INPU
                                            label="نام سفارش"
                                            styleview={{ width: "80%", }}
                                            stylelabel={{ width: "25%",backgroundColor:"white" }}
                                            value={State.name}
                                            onChangeText={(text) => setState({ ...State, name: text })}
                                            styleinput={Platform.OS === "web" && { outlineColor: Colors.primary }}
                                            keyboardType="default"
                                            placeholder={item.name}
                                        />

                                        <Btn
                                            label="ویرایش"
                                            style={{ width: "20%", height: 60 }}
                                            textStyle={{ bottom: 10, fontSize: 13, }}
                                            touchableStyle={{ backgroundColor: Colors.primary }}
                                            onPress={() => {
                                                SendNameHandler(item.id)

                                                setState({ ...State, name: "" })}
                                            
                                            }
                                           


                                        />

                                    </View>


                                    <View style={styles.viewline} >

                                        <Text style={styles.textlineR}>نام سفارش : <Text style={styles.textline}>{item.name}</Text></Text>

                                        {item.message !== null && item.message.seen == "no" && item.message.status != "user" ?
                                            <TouchableOpacity style={styles.menu1} onPress={() => props.navigation.navigate("chat", {
                                                idservice: item.id
                                            })}  >
                                                <MaterialCommunityIcons name={"bell-ring"} size={30} color={Colors.greenalarm} />
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.success }}>پیام جدید </Text>
                                            </TouchableOpacity> :
                                            <View></View>}
                                        {/* 
                                        {item.message == null     ?
                                            <View></View>
                                            : item.message.status == "user"?
                                            <View></View>
                                            :item.message.seen == "yes"?
                                            <View></View>:

                                            <TouchableOpacity style={styles.menu1} onPress={() => props.navigation.navigate("chat", {
                                                idservice: item.id
                                            })}  >
                                                <MaterialCommunityIcons name={"bell-ring"} size={30} color={Colors.greenalarm} />
                                                <Text style={{ fontFamily: "Montserrat", fontSize: 10, color: Colors.success }}>پیام جدید </Text>
                                            </TouchableOpacity>
                                        } */}

                                    </View>





                                    <View style={styles.viewline} >

                                        <Text style={styles.textlineR}>کد سفارش : <Text style={styles.textline}>{item.number}</Text></Text>
                                    </View>

                                    <View style={styles.viewline} >

                                        <Text style={styles.textlineR}> نوع سفارش : <Text style={styles.textline}>{item.category.title}</Text></Text>
                                    </View>
                                    <View style={styles.viewline} >

                                        <Text style={styles.textlineR}> تاریخ تحویل : <Text style={styles.textline}>{item.time_estimate}</Text></Text>
                                    </View>

                                    <View style={styles.viewline} >

                                        <Text style={styles.textlineR}>نحوه سفارش : <Text style={styles.textline}>{item.type == "chat" ? "ثبت پیشرفته (چت)" : "ثبت سریع (برش ونوار)"}</Text></Text>
                                    </View>
                                    {item.price == "0" ?
                                        null :
                                        <View style={styles.viewline} >

                                            <Text style={styles.textlineR}>قیمت : <Text style={styles.textline}>{item.price}</Text></Text>
                                        </View>}


                                    <SafeAreaView style={{ width: "100%", flexDirection: "row", justifyContent: "center" }}>

                                        <View style={{ width: "100%", flexDirection: "row", justifyContent: "center", marginTop: 10, marginBottom: 10 }}>

                                            {item.files_app.length > 0 ?

                                                <Btn
                                                    label="فایلهای طراحی شده"
                                                    style={{ width: "25%", marginTop: 10, marginLeft: 10 }}
                                                    textStyle={{ bottom: 10, fontSize: 10, }}
                                                    touchableStyle={{ backgroundColor: Colors.yellowdark }}
                                                    onPress={() => props.navigation.navigate("ordercolor", {
                                                        file: item.files_app,
                                                        name: ""
                                                    })}


                                                />
                                                : <View></View>
                                            }


                                            {item.payment_link == false ?
                                                <View></View>
                                                :
                                                <Btn
                                                    label={item.payment_status == true ? " پرداخت شده" : "پرداخت"}
                                                    style={{ width: "25%", marginTop: 10, }}
                                                    textStyle={{ bottom: 10, fontSize: 12, }}
                                                    touchableStyle={{ backgroundColor: item.payment_status == true ? Colors.secondText3 : Colors.primary }}
                                                    onPress={() => {
                                                        item.payment_status == true ?
                                                            "" :
                                                            handleOpenWithLinkingPayment(item.payment_link)
                                                    }}

                                                />

                                            }
                                            <Btn
                                                label="گفتگو با اپراتور"
                                                touchableStyle={{ backgroundColor: Colors.success }}
                                                style={{ width: Platform.OS === "web" ? "25%" : "25%", marginTop: 10, }}
                                                textStyle={{ bottom: 10, fontSize: 12, }}
                                                onPress={() => props.navigation.navigate("chat", {
                                                    idservice: item.id
                                                })}

                                            />



                                            {item.three_dfiles_app.length > 0 ?



                                                <Btn
                                                    label="فایل سه بعدی"
                                                    style={{ width: "25%", marginTop: 10, }}
                                                    touchableStyle={{ backgroundColor: Colors.blue }}
                                                    textStyle={{ bottom: 10, fontSize: 12, }}

                                                    onPress={() => props.navigation.navigate("ordercolor", {
                                                        file3D: item.three_dfiles_app,
                                                        name: "3D"
                                                    })}
                                                /> :
                                                <View></View>
                                            }

                                        </View>
                                    </SafeAreaView>

                                </View>

                            )

                        }}


                    />

                    :
                    <View style={{ width: "80%", height: 130, marginBottom: "70%", backgroundColor: Colors.secondText3, left: "10%", padding: 5, borderRadius: 10, marginTop: 20 }}>
                        <Text style={{ fontFamily: "MontserratBold", fontSize: 15, color: Colors.background, textAlign: "center", marginTop: "5%" }}>شما تاکنون سفارشی ثبت نکردید</Text>
                        <Btn
                            label="سفارش جدید"
                            style={{ marginLeft: "5%", marginTop: "5%", marginBottom: "10%", height: 55 }}

                            textStyle={{ bottom: 10 }}

                            onPress={() => {

                                props.navigation.navigate("order")
                            }} />



                    </View>

                }






                <View style={{
                    flexDirection: "row",
                    width: isSmallScreen ? "100%" : 500,
                    height: 60,
                    backgroundColor: Colors.primary,
                    position: Platform.OS === "web" ? "fixed" : "relative",
                    bottom: 0,

                }}>
                    <View style={{ width: "15%", height: 60, position: "absolute", right: "5%", alignItems: "center", }}>
                        {/* <Ionicons name="reader-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            سفارشات
                        </Text> */}
                        <View style={{ width: 50, height: 50, borderRadius: 25, backgroundColor: Colors.yellowlight, borderWidth: 5, borderColor: Colors.background, bottom: 28, alignItems: "center", justifyContent: "center" }}>
                            <Ionicons name="reader-outline" size={20} color={Colors.background} />
                        </View>

                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.yellow, position: 'absolute', bottom: 15 }}>
                            سفارشات
                        </Text>
                        <View style={{ width: 30, height: 5, borderRadius: 5, backgroundColor: Colors.yellowlight, position: 'absolute', bottom: 5 }}></View>

                    </View>






                    <TouchableOpacity onPress={() => props.navigation.navigate("profile")} style={{ width: "15%", height: 60, alignItems: "center", left: 15, top: 5 }}>
                        <MaterialCommunityIcons name="badge-account-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            پروفایل
                        </Text>
                    </TouchableOpacity>









                    <TouchableOpacity onPress={() => props.navigation.navigate("home")} style={{ width: "30%", height: 60, left: "35%", position: "absolute", alignItems: "center", flexDirection: "column" }}>

                        <Ionicons name="home-outline" size={25} color={Colors.background} />
                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.background }}>
                            صفحه اصلی
                        </Text>
                        {/* <View style={{ width: 50, height: 50, borderRadius: 25, backgroundColor: Colors.yellowlight, borderWidth: 5, borderColor: Colors.background, bottom: 28, alignItems: "center", justifyContent: "center" }}>
                            <Ionicons name="home-outline" size={20} color={Colors.background} />
                        </View>

                        <Text style={{ fontFamily: "Montserrat", fontSize: 12, color: Colors.yellow, position: 'absolute', bottom: 15 }}>
                            صفحه اصلی
                        </Text>
                        <View style={{ width: 30, height: 5, borderRadius: 5, backgroundColor: Colors.yellowlight, position: 'absolute', bottom: 5 }}></View>
                    */}
                    </TouchableOpacity>


                </View>




                <AwesomeAlert
                    show={ERROR}
                    showProgress={false}
                    title={Massage == "با موفقیت ثبت شد" ? "" : "اخطار"}
                    message={Massage}
                    closeOnTouchOutside={false}
                    closeOnHardwareBackPress={false}
                    // showCancelButton={true}
                    showConfirmButton={true}
                    // cancelText="باشه"
                    confirmText="باشه"
                    confirmButtonColor={Colors.success}
                    // onCancelPressed={() => {
                    //   setShow(false);
                    // }}
                    onConfirmPressed={() => {
                       
                        setError(false);
                        //  props.navigation.navigate("orderlist");
                       
                        setOffset(2)
                        getORDERHandler()
                        

                    }}
                    titleStyle={{ fontFamily: "MontserratBold", fontSize: 13, color: "red" }}
                    messageStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                    confirmButtonTextStyle={{ fontFamily: "Montserrat", fontSize: 13 }}
                />


            </View>
        </NativeBaseProvider>

    );
}

const styles = StyleSheet.create({

    viewContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: Colors.background,
        position: Platform.OS == "web" ? "fixed" : "relative"
    },
    viewHeader: {
        flexDirection: "row",
        width: "100%",
        height: Platform.OS == "web" ? 60 : 80,
        backgroundColor: Colors.primary,
    },
    textheader: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 50,
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        right: "10%",
        
        top: Platform.OS == "web" ? "15%" : "25%",
    },
    menu: {
        backgroundColor: Colors.primary,
        width: 40,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: 15,
        top: Platform.OS == "web" ? "23%" : "33%",


    },
    menu3: {
        backgroundColor: Colors.primary,
        width: 80,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        left: "40%",
        top: Platform.OS == "web" ? "15%" : "35%",
    },
    filter: {
        backgroundColor: Colors.primary,
        width: 110,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        position: "absolute",
        left: "3%",
        top: Platform.OS == "web" ? "15%" : "32%"
    },
    filter1: {
        backgroundColor: Colors.green,
        width: 80,
        height: 40,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "row",
        position: "absolute",
        left: "38%",
        borderRadius:10,
        top: Platform.OS == "web" ? "15%" : "32%"
    },
    textmodal: {
        fontFamily: "Montserrat",
        fontSize: 16,
        color: Colors.black,
        position: "absolute",
        right: "1%",
        top: "5%"
    },
    viewfooter: {
        flexDirection: "row",
        width: "100%",
        height: 60,
        backgroundColor: Colors.primary,
        position: Platform.OS === "web" ? "fixed" : "relative",
        bottom: 0,

    },

    menu1: {

        width: 60,
        height: 40,
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        left: 15,
        top: "35%",


    },

    textinput: {
        paddingLeft: Platform.OS === "web" ? "35%" : 0,
        flexDirection: "row",
        width: "90%",
        height: 60,
        backgroundColor: Colors.background2,
        position: "absolute",
        left: "5%",
        borderRadius: 10,
        borderWidth: 1,
        borderColor: Colors.secondText3,
        padding: 10,
        paddingRight: 50,
        paddingLeft: 10,
        fontFamily: "Montserrat",
        marginTop: 15,
        fontSize: 12


    },




    view: {
        flexDirection: "column",
        alignItems: "center",
        width: "90%",
        alignSelf: "auto",
        backgroundColor: Colors.background1,
        marginTop: 10,
        left: "5%",
        borderWidth: 2,
        borderColor: Colors.secondText,
        borderRadius: 10,

        marginBottom: 10

    },





    viewline: {
        width: "100%",
        height: 30,
        justifyContent: "center",
        flexDirection: "row",
        marginTop: 5

    },

    textlineR: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.black,
        position: "absolute",
        right: "5%"

    },
    textline: {
        fontFamily: "Montserrat",
        fontSize: 13,
        color: Colors.secondText3,

    },


    footer: {
        padding: 10,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
    },
    loadMoreBtn: {
        padding: 10,
        backgroundColor: Colors.primary,
        borderRadius: 4,
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    btnText: {
        color: Colors.background,
        fontSize: 15,
        textAlign: 'center',
        fontFamily: "MontserratBold",
    },
})




export default Orderlist